import Vue from 'vue';

import { uuid } from '@/helpers/uuid';
import AppleAuth from '@/packages/appleAuthPackage';

export default function installApplePlugin() {
  Vue.use(AppleAuth, {
    clientId: `${import.meta.env.VITE_APPLE_CLIENT_ID}`,
    scope: 'name email',
    redirectURI: `${import.meta.env.VITE_APPLE_REDIRECT_URI}`,
    state: uuid(),
    nonce: uuid(),
  });
}
